export enum ActionTypes {
  LOAD_MAINTENANCE_ITEM_OPTIONS_REQUEST = 'LOAD_MAINTENANCE_ITEM_OPTIONS_REQUEST',
  LOAD_MAINTENANCE_ITEM_OPTIONS_SUCCEEDED = 'LOAD_MAINTENANCE_ITEM_OPTIONS_SUCCEEDED',
  LOAD_MAINTENANCE_ITEM_OPTIONS_FAILED = 'LOAD_MAINTENANCE_ITEM_OPTIONS_FAILED',

  MARK_MAINTENANCE_AS_DONE_REQUEST = 'MARK_MAINTENANCE_AS_DONE_REQUEST',
  EDIT_MAINTENANCE_REQUEST = 'EDIT_MAINTENANCE_REQUEST',
  REGISTER_MAINTENANCE_REQUEST = 'REGISTER_MAINTENANCE_REQUEST',

  DELETE_MAINTENANCE_REQUEST = 'DELETE_MAINTENANCE_REQUEST',
  SAVE_MAINTENANCE_MARKED_AS_DONE_REQUEST = 'SAVE_MAINTENANCE_MARKED_AS_DONE_REQUEST',
  SAVE_MAINTENANCE_REGISTRY_REQUEST = 'SAVE_MAINTENANCE_REGISTRY_REQUEST',
}
